import React from 'react'
import { DealStep } from '../models/shared/DealStep'
import { Deal } from '../models/shared/Deal'
import { DealCardPlaceholder, DealCardWrapper } from './DealCard'
import { useText } from '../context/TextContext'
import { AdvancedButton } from './AdvancedButton'
import { SortableContext } from '@dnd-kit/sortable'
import { useDroppable } from '@dnd-kit/core'
import DealsBadge from './DealsBadge'
import { CardLayout } from '../models/shared/CardLayout'
import { DEFAULT_STEP_COLOR } from '../utils/shared/constants'

interface Props {
    layout: CardLayout
    step: DealStep,
    deals: Deal[],
    handleNewDeal: (stepId: string) => Promise<void>,
    onDealSelect: (deal: Deal) => void
    onDealArchive: (deal: Deal) => void
    onDealShare: (deal: Deal) => void
    disableAddDeal?: boolean
    noNewDeals?: boolean
}

function DealStepColumn(props: Props) {
    const { step, deals } = props
    const [processing, setProcessing] = React.useState(false);
    const text = useText();
    const { setNodeRef, isOver } = useDroppable({
        id: `step-${step.id}`,
        data: {
            stepId: step.id,
            useLastOrder: true,
        }
    });

    const handleNewDeal = async (stepId: string) => {
        setProcessing(true);
        await props.handleNewDeal(stepId);
        setProcessing(false);
    }

    return <SortableContext items={deals.map(deal => deal.id || '')} >
        <div className="col p-0" ref={setNodeRef}
            style={{ scrollSnapAlign: 'center' }}
        >
            <div className='p-2 border rounded d-flex flex-column gap-3'
                style={{ backgroundColor: step.color || DEFAULT_STEP_COLOR }}>
                <div className='d-flex align-items-center gap-2 '>
                    <h6 className="m-0">{step.name}</h6>
                    <DealsBadge dealCount={deals.length} />
                </div>

                {deals.map(deal => <DealCardWrapper layout={props.layout} key={deal.id} deal={deal}
                    onDealArchive={props.onDealArchive}
                    onDealSelect={props.onDealSelect}
                    onDealShare={props.onDealShare}
                />)}

                {isOver && <DealCardPlaceholder />}

                {!props.noNewDeals &&
                    <AdvancedButton processing={processing} icon='bi-plus' variant="ghost" size='sm' className='deal-btn'
                        disabled={props.disableAddDeal}
                        onClick={() => handleNewDeal(step.id)}>{text.newDeal}</AdvancedButton>
                }
            </div>
        </div>
    </SortableContext>
}

export default DealStepColumn
